import { useEffect, useRef, useState } from "react";

type Props = {
  onSend: (text: string) => void;
  disabled?: boolean;
  autoFocus?: boolean;
};

export function Composer({ onSend, disabled, autoFocus }: Props) {
  const [value, setValue] = useState("");
  const ref = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    if (autoFocus && ref.current) ref.current.focus();
  }, [autoFocus]);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, 220)}px`;
  }, [value]);

  const send = () => {
    const text = value.trim();
    if (!text || disabled || text.length > 2000) return;
    onSend(text);
    setValue("");
  };

  return (
    <div className="sa-chat-composer">
      <div className="sa-chat-composer__inner">
        <div className="sa-chat-composer__field">
          <textarea
            ref={ref}
            className="sa-chat-composer__textarea"
            rows={1}
            value={value}
            disabled={disabled}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                send();
              }
            }}
            placeholder="Pose an inquiry..."
            aria-label="Pose an inquiry"
            maxLength={2100}
            style={{
              fontFamily: "var(--sa-serif)",
              fontSize: 17,
              lineHeight: 1.5,
              maxHeight: 220,
            }}
          />
          <button
            onClick={send}
            disabled={disabled || !value.trim()}
            className="sa-btn sa-chat-composer__send"
            style={{ padding: "8px 16px", fontSize: 12 }}
          >
            Send {"->"}
          </button>
        </div>
        <div className="sa-chat-composer__meta">
          <span>Enter to send, Shift+Enter for a new line.</span>
          <span className="sa-mono" style={{ fontFamily: "var(--sa-mono)" }}>
            {value.length > 1800 ? `${value.length} / 2000` : ""}
          </span>
        </div>
      </div>
    </div>
  );
}
